// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2rl7k","content":"styles_content__2_zEH","checkbox":"styles_checkbox__37pX_","checkboxLabel":"styles_checkboxLabel__1l-WW"};